export interface ISystemPromptVersion {
  id: string
  agentId: string
  versionNumber: number
  isCurrent: boolean
  systemPrompt: string
  createdOn?: string
  createdBy?: string
}

/**
 * One immutable system-prompt history row.
 */
export class SystemPromptVersion implements ISystemPromptVersion {
  id: string
  agentId: string
  versionNumber: number
  isCurrent: boolean
  systemPrompt: string
  createdOn?: string
  createdBy?: string

  constructor(systemPromptVersion: Partial<ISystemPromptVersion>) {
    Object.assign(this, systemPromptVersion)
  }
}
